import { getLanguagePrefix } from "./Internationalization/handleAppInternationalization";

export const getLocalizedBaseUrl = (type) => {

  const countryCode = localStorage.getItem("ECOPROCTRYCODE")?.toUpperCase();
  if (!countryCode) return "";

  const baseUrl = window.env[`${type}_${countryCode}`];
  if (!baseUrl) return "";

  // Primary source of language
  let lang = getLanguagePrefix();

  const multiLingualCountries = {
    BE: ["nl", "fr"],
    CH: ["de", "fr"]
  };

  // Handle multilingual countries
  if (multiLingualCountries[countryCode]) {

    // fallback to default if invalid / missing
    if (!multiLingualCountries[countryCode].includes(lang)) {
      lang = multiLingualCountries[countryCode][0];
    }

    const locale = `${lang.toLowerCase()}-${countryCode.toLowerCase()}`;

    const url = new URL(baseUrl);

    const cleanPath = url.pathname.startsWith("/")
      ? url.pathname
      : `/${url.pathname}`;

    return `${url.origin}/${locale}${cleanPath}`;
  }

  // Non-multilingual → return as is
  return baseUrl;
};
